import React from 'react'

import { BaseComponentProps } from '../../types/component'

const MainLayout: React.FC<BaseComponentProps> = ({
  children,
  additionalClasses,
  additionalStyles,
}) => {
  return (
    <div
      className={`main max-w-4xl h-full mx-auto p-4 md:p-8 ${additionalClasses}`}
      style={additionalStyles}
    >
      {children}
    </div>
  )
}

export default MainLayout
